import { render, staticRenderFns } from "./module.vue?vue&type=template&id=4fd016ba&scoped=true"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"
import style0 from "./module.vue?vue&type=style&index=0&id=4fd016ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd016ba",
  null
  
)

export default component.exports